// Class: starling.display._MovieClip.MovieClipFrame

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $import = require("./../../../import_stub").default;
function js__$Boot_HaxeError() {return require("./../../../js/_Boot/HaxeError");}
function openfl_errors_Error() {return $import(require("openfl/errors/Error"));}

// Constructor

var MovieClipFrame = function(texture,duration,startTime) {
	if(startTime == null) {
		startTime = 0;
	}
	if(duration == null) {
		duration = 0.1;
	}
	this.texture = texture;
	this.duration = duration;
	this.startTime = startTime;
}

// Meta

MovieClipFrame.__name__ = ["starling","display","_MovieClip","MovieClipFrame"];
MovieClipFrame.prototype = {
	playSound: function(transform) {
		if(this.sound != null) {
			this.sound.play(0,0,transform);
		}
	},
	executeAction: function(movie,frameID) {
		if(this.action != null) {
			var numArgs = 2;
			if(numArgs == 0) {
				this.action();
			} else if(numArgs == 1) {
				this.action(movie);
			} else if(numArgs == 2) {
				this.action(movie,frameID);
			} else {
				throw new (js__$Boot_HaxeError().default)(new (openfl_errors_Error().default)("Frame actions support zero, one or two parameters: " + "movie:MovieClip, frameID:int"));
			}
		}
	},
	get_endTime: function() {
		return this.startTime + this.duration;
	}
};
MovieClipFrame.prototype.__class__ = MovieClipFrame.prototype.constructor = $hxClasses["starling.display._MovieClip.MovieClipFrame"] = MovieClipFrame;

// Init



// Statics




// Export

exports.default = MovieClipFrame;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/display/_MovieClip/MovieClipFrame.js
// module id = 299
// module chunks = 0